import { Injectable } from '@angular/core';
import { CommentControllerService } from '@osos/shared/api';
import { RefProperty } from '@osos/shared/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataCommentsService extends CommentControllerService {
  getAudience({
    keyword,
  }: {
    keyword: string;
  }): Observable<Array<RefProperty>> {
    return this.getAudienceList({
      keyword,
    });
  }
}
